import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

export const VendorMappingConfirmationDialog = (props) => {
	return (
		props.isOpen && <Dialog
			open={props.isOpen}
			aria-labelledby="draggable-dialog-title"
		>
			<DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
				{props.title}
			</DialogTitle>
			<DialogContent>
				<DialogContentText>
					{props.message}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button autoFocus onClick={(event) => { props.onClose({...event,response:'Y'}) } } color="primary">
					Yes
				</Button>
				<Button autoFocus onClick={(event) => { props.onClose({ ...event, response: 'N' }) }} color="primary">
					No
				</Button>
			</DialogActions>
		</Dialog>
	);
}